import { type InterestsFormSchema, monthOptions } from '@/_containers';
import { defaultStatus } from '@/_schemas/status-input';

import type { ContactFormSchema } from '../schemas';

export const defaultValues = {
  id: -1,
  first_name: '',
  last_name: '',
  email: '',
  title: '',

  birthdate: null,

  spouse_name: '',
  children_names: '',
  pet_names: '',
  linked_in_url: '',
  twitter_handle: '',
  profile_image: null,
  status: defaultStatus,
  birth_day: { name: '', value: '' },
  birth_month: monthOptions[0],
  remote_worker: '0' as '0' | '1',

  interests: [] as InterestsFormSchema[],
  phone_numbers: null,
  addresses: null,
  friends: [],
  work_anniversary: undefined,
  wedding_anniversary: undefined,
  clients: [],
  emails: [],
  freshdesk: '',
} as ContactFormSchema;
